/** @format */

import { useEffect, useMemo, useState } from 'react';
import { getFileStats } from '../../../../Services/service.datadetails';
import {
  useReactTable,
  getCoreRowModel,
  createColumnHelper,
} from '@tanstack/react-table';
import { Box } from '@mui/system';
import './../../../../Style/react-table.css';
import SyncStutus from './Table/SyncStatus';
import TableHeader from './Table/TableHeader';
import TableBody from './Table/TableBody';
import AboutFile from './AboutFile';

const columnHelper = createColumnHelper();

const sectionStyle = {
  p: 2,
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'flex-start',
};

function FileStat() {
  const [data, setData] = useState([]);
  const [aboutData, setAboutData] = useState({});

  const columns = useMemo(() => {
    if (data.length) {
      const columnNames = Object.keys(data[0]);
      return columnNames.map((columnName) =>
        columnHelper.accessor(columnName, {
          // header: columnName, same as accessorKey
          cell: (info) => {
            console.count();
            if (columnName === 'Sync Status')
              return <SyncStutus value={info.getValue()} />;
            else return info.getValue();
          },
        })
      );
    }
    return [];
  }, [data]);

  const table = useReactTable({
    columns,
    data,
    getCoreRowModel: getCoreRowModel(),
  });
  useEffect(() => {
    getFileStats({}).then((response) => {
      const { Status, Value, ...restData } = response.data;
      setAboutData(restData);
      if (Value.length) setData(Value);
    });
  }, []);

  return (
    <Box component="section" sx={sectionStyle}>
      <Box component="table" className="table" sx={{ pr: 2 }}>
        <TableHeader headerGroups={table?.getHeaderGroups()} />
        <TableBody rows={table?.getRowModel().rows} />
      </Box>
      <AboutFile aboutData={aboutData} />
    </Box>
  );
}

export default FileStat;
